// src/modules/app-views/dataSearch/pages/Historic/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SearchOutlined } from '@ant-design/icons';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
// No constants needed

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************

/**
 * Action button configuration for DataSearch Historic page
 * Navigates to search page (init) when clicked
 */
function dataSearchHistoricActionButton() {
  return {
    action: 'new',
    hideButton: false,
    label: 'new_search',
    tooltip: 'new_data_search',
    icon: <SearchOutlined />,
    type: 'primary',
    disabled: false,

    // Primary button handler - navigation to search page (init)
    onClick: function handleClick({ navigate, setPage }) {
      setPage({
        navigate,
        pageName: 'init',
      });
    },

    // No dropdown for this button
    dropdownItems: [],
  };
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default dataSearchHistoricActionButton;
